import { useLocation } from 'react-router-dom';
import { TbIcon } from 'components/Figma';
import { DrillDownEntryCard } from 'components/Layout/Tiles/DrillDownEntryCard';

const CARDS = [
  {
    labelId: 'profitability.investigate.category.title',
    to: '/profitability/prdCategory',
    testid: 'investigate-category-card',
  },
  {
    labelId: 'profitability.investigate.marketplace.title',
    to: '/profitability/chnMarketplace',
    testid: 'investigate-marketplace-card',
  },
  {
    labelId: 'profitability.investigate.country.title',
    to: '/profitability/chnCountry',
    testid: 'investigate-country-card',
  },
];

const icon = <TbIcon name="Investigate" size="xl" />;

export function InvestigateProfitabilitySection() {
  const location = useLocation();

  return (
    <>
      {CARDS.map(({ labelId, to, testid }) => (
        <DrillDownEntryCard key={testid} icon={icon} labelId={labelId} to={to + location.search} testid={testid} />
      ))}
    </>
  );
}
